/**
 * The absolute path an app is mounted at: the app's segment under the customer a session is scoped
 * to (`/c/banner/scout`).
 *
 * One owner for the string, so an app switch and the header's nav cannot disagree about the shape of
 * a customer-scoped app path, and `/c/` stays a prefix only the shell knows. An app is told its mount
 * path rather than building one, because every link an app renders is relative (Atlas ADR-0021).
 *
 * A copy of arc's `shell/app/appMountPath.ts`, deliberately the same module in the same place, so
 * Scout's move into the suite deletes this file rather than reconciling it. The customer is
 * percent-encoded here, matching every other path builder in Scout: it comes from the URL, so it is
 * not guaranteed path-safe. Arc's copy does not encode it yet.
 */
export const appMountPath = (customer: string, appId: string): string =>
  `/c/${encodeURIComponent(customer)}/${appId}`
